export default __webpack_public_path__ + "static/media/construction-hat.ab2dea9a.png";